
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import Scroll from '@/components/scroller'
import config from '@/config/index'
import { getNewslist } from '@/api/youzheng.js'
export default {
name: 'youwenhua',
data () {
return {
baseUrl: config.baseUrl,
owner_type: config.owner_type,
newslist: [],
notFirstLoad: false,
loadMoreDom: null,
pagecurent: 1,
pagesize: 20,
category: this.$route.params.category,
show: false
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
created () {
},
components: {
Flexbox,
FlexboxItem,
Scroll
},
mounted () {
this.loadMoreDom = this.$el.querySelector('.load-more')
this.listDom = this.$el.querySelector('.list-scroll')
this.getlist(this.category, this.pagesize, 1)
},
methods: {
getlist (CATEGORYCODE, pagesize, pagecurent, type, done) {
getNewslist({
CATEGORYCODE: 'cat11_01',
pageSize: pagesize,
pageCurrent: pagecurent,
CHANNELCODE: 'ch11',
owner_type: config.owner_type,
searchValue: ''
}).then(res => {
if (type === 'refresh' || type === 'search') {
this.newslist = []
this.listDom.scrollTop = 0
}
if (res.obj !== '' && res.obj.length > 0) {
res.obj.forEach(item => {
this.newslist.push(item)
})
}
if (res.obj.length === 0 && pagecurent == 1) {
this.loadMoreDom.style.display = 'none'
this.notFirstLoad = true
} else {
this.loadMoreDom.style.display = 'flex'
this.notFirstLoad = false
}
if (
res.obj.length === 0 ||
res.obj.length < pagesize
) {
this.loadMoreDom.innerText = '我也是有底线的～o～'
setTimeout(() => {
this.loadMoreDom.style.display = 'none'
}, 2000)
}
done && done()
})
},

refresh (done, index) {
this.pagecurent = 1
this.loadMoreDom.innerText = '加载中...'
this.getlist(this.category, this.pagesize, this.pagecurent, 'refresh', done)
},

loadMore (done, index) {
this.pagecurent++
this.getlist(this.category, this.pagesize, this.pagecurent, 'more', done)
}
}
}
